module.exports = __webpack_public_path__ + "static/media/step2.589d3701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/step2.jpg
// module id = 770
// module chunks = 0